import {
  Box,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import React, { useState, useRef } from 'react';
import Header from './Header';

import { Link } from 'react-router-dom';

import LogoutIcon from '@mui/icons-material/Logout';
import companyLogo from '../assets/images/Logo/logo-only-kg.jpg';
// import Sidebar from './vertical/sidebar/Sidebar';

import {
  Close as CloseIcon,
  Dashboard as DashboardIcon,
} from '@mui/icons-material';
import '../assets/css/style.css';
import Sidenav from '../layout/Sidenav';
import { useNavigate } from 'react-router-dom';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { handleLogout } from '../commonFunctions/logout';
import transitions from '@material-ui/core/styles/transitions';

function Layout(props) {
  const navigate = useNavigate();

  // const handleLogout = () => {
  //   localStorage.removeItem("user");
  //   localStorage.removeItem("projectID");
  //   navigate("/");
  // };

  const [menuOpenedFlag, setMenuOpenedFlag] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const showMenuIcon = () => {
    setMenuOpenedFlag(!menuOpenedFlag);
  };
  const activeUrl = window.location.pathname;
  const userData = JSON.parse(localStorage.getItem('user'));

  return (
    <Box>
      <Grid container>
        <Grid
          className={`sidenav ${menuOpenedFlag ? `open` : `close`}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          sx={{
            width: menuOpenedFlag || isHovered ? '280px' : '70px',
            transition: 'all 0.3s ease',
            overflowX: 'hidden',
            height: '100vh',
            position: 'fixed',
            // backgroundColor: '#0C53A0',
            zIndex: 1000,
          }}
        >
          {/* <Grid textAlign={`right`}>
            <IconButton
              size='large'
              aria-label='account of current user'
              aria-controls='menu-appbar'
              aria-haspopup='true'
              onClick={showMenuIcon}
              color='inherit'
              className='btn'
            >
              <CloseIcon sx={{ color: `white` }} />
            </IconButton>
          </Grid> */}
          <List>
            <ListItem disablePadding sx={{ display: 'block' }}>
              <Box
                sx={{
                  minHeight: 48,
                  px: 2.5,
                  py: 2,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '15px',
                  // backgroundColor: "#e9ecef",
                  borderRadius: '15px',
                }}
              >
                <img
                  src={companyLogo}
                  alt='KG'
                  width={menuOpenedFlag || isHovered ? `150px` : `40px`}
                  height={`auto`}
                  style={{ transitions: 'width 0.3s ease' }}
                />
                {/* <Typography
                  variant="h4"
                  sx={{ fontWeight: "bold", color: "#0C53A0" }}
                >
                  KG
                </Typography> */}
              </Box>

              {/* {userData.role_id === 35 || userData.role_id === 34 ? (
                <>
                  <Grid className="left-menu">
                    <Grid textAlign="left" item xs={6} lg={12} md={12}>
                      <Typography>Project Name : {"true" === localStorage.getItem("isProjectLoggedIn") ? (
                        <>{localStorage.getItem("projectName")}</>
                      ) : (
                        <>-</>
                      )}</Typography>
                    </Grid>
                    <Grid textAlign="left" item xs={6} lg={12} md={12}>
                      <Typography>Check-In Time :   {"true" === localStorage.getItem("isProjectLoggedIn") ? (
                        <>{localStorage.getItem("projectCheckInTime")}</>
                      ) : (
                        <>-</>
                      )}</Typography>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <></>
              )} */}
              <Grid className='left-menu'>
                <Sidenav isSidebarOpen={menuOpenedFlag || isHovered} />
              </Grid>
              <Link onClick={handleLogout} className={`logout-btn`}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    px: 2.5,
                    display: 'flex',
                    gap: '15px',
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      justifyContent: 'center',
                    }}
                  >
                    <PowerSettingsNewIcon />
                  </ListItemIcon>
                  <ListItemText primary='Logout' />
                </ListItemButton>
              </Link>
            </ListItem>
          </List>
        </Grid>
        {/* <Grid className={`topnav ${!menuOpenedFlag ? 'full-width' : ''}`}>
          <Header menuAction={showMenuIcon} menuOpenedFlag={menuOpenedFlag} />
          {props.children}
        </Grid> */}
        <Grid
          className='topnav'
          sx={{
            marginLeft: menuOpenedFlag
              ? { xl: '280px', lg: '240px', sm: '0px' }
              : '60px',
            width: menuOpenedFlag
              ? {
                  xl: 'calc(100vw - 280px)',
                  lg: 'calc(100vw - 240px)',
                  sm: '100vw',
                }
              : 'calc(100vw - 60px)',
            transition: 'all 0.3s ease',
          }}
        >
          <Header
            menuAction={showMenuIcon}
            menuOpenedFlag={menuOpenedFlag}
            isHovered={isHovered}
          />
          {props.children}
        </Grid>
      </Grid>
    </Box>
  );
}

export default Layout;
